import React, { useRef } from 'react';
import { Container, Grid, Typography } from '@mui/material';
import topImg from '../../../Img/2monitors.jpg'
import ListSettings from '../../Components/ListSettings';
import SegmentsRounded from '../../Components/SegmentsRounded';

const SettingsOnlineBuhgalterPage = () => {
    
const inputRef = [useRef(null), useRef(null), useRef(null), useRef(null), useRef(null), useRef(null), useRef(null), useRef(null)]

const listSettingsLink = [
    { link: '', title: 'Первый запуск', ref: inputRef[0] },
    { link: '', title: 'Настройки Профиля Пользователя', ref: inputRef[1] },
    { link: '', title: 'Настройки Профиля Компании', ref: inputRef[2] },
    { link: '', title: 'Справочники: Товары/Услуги', ref: inputRef[3] },
    { link: '', title: 'Справочники: Контрагенты', ref: inputRef[4] },
    { link: '', title: 'Справочники: Адреса доставки', ref: inputRef[5] },
    { link: '', title: 'Справочники: Группы расходов', ref: inputRef[6] },
    { link: '', title: 'Справочники: Точки продаж', ref: inputRef[7] },
]

const data_block_segments = [
    {
        title: 'Регистрация',
        text_segment: [
            'Для того чтобы пользоваться системой Online Бухгалтер FinUp.kz, необходимо пройти Регистрацию.',
            'Во время Регистрации необходимо указать: Имя, Фамилию, электронную почту(в дальнейшем она будет использоваться как Логин для входа в приложение) и пароль.',
            'Необходимо поставить галочку "Я ознакомился и согласен с условиями", без отметки о том что вы прочитали и согласны с договорм Оферты, регистрация не возможна.'
        ],
        text_segment_bold: [
            '',
            '',
            ''
        ],
        img: 0,
    },
    {
        title: 'Первый запуск',
        text_segment: [
            'После регистрации необходимо заполнить всю информацию о Пользователе и Компании, а также Справочники: Товаров/Услуг, Контрагенты(Клиенты), Адреса доставки (если нужно).',
            'Порядок заполнения информации:',
            'Настройки Профиля Пользователя',
            'Настройка Профиля Компании',
            'Справочники',
            '',
        ],
        text_segment_bold: [
            '',
            '',
            '1. ',
            '2. ',
            '3. ',
            '',

        ],
        img: 1,
        ref: inputRef[0]
    },
    {
        title: 'Настройки Профиля Пользователя',
        text_segment: [
            'Вводим данные о Пользователе.',
            'Обязательно заполняем все поля:',
            'Имя, Фамилия и Почта заполняются автоматически после регистрации.',
            'Необходимо указать телефон.',
            'Необходимо заполнить поле КНП (Код Назначения Платежа). В дальнейшем он будет использоваться в Счетах на оплату.',
            'Отметьте галочкой все документы с которыми планируете работать, далее эти типы документов будут доступны в заявке (в любое время можно изменить). ЭСФ - автоматически пока не отправляется, отметку по отправке ЭСФ необходимо нажимать после того как вы или Бухгалтер отправит ЭСФ в системе ИС ЭСФ (https://esf.gov.kz/).',
            'Также вы можете выбрать "Точку продажы", и установить её по умолчанию для документов, это необходимо для корректного подсчета ФНО 913, при работе на налоговом режиме "Розничный налог".',
            'По кнопке ‘ИЗМЕНИТЬ ПАРОЛЬ’, можно сменить пароль, для этого необходимо ввести старый пароль и новый пароль, нажать на кнопку ‘СОХРАНИТЬ’.',
            '',
        ],
        text_segment_bold: [
            '',
            '',
            '1. ',
            '2. ',
            '3. ',
            '4. ',
            '5. ',
            '6. ',
            '',

        ],
        img: 2,
        ref: inputRef[1]
    },
    {
        title: 'Настройки Профиля Компании',
        text_segment: [
            'Вводим данные о Компании.',
            'Обязательно заполняем все поля: ',
            'Наименование компании - указать полное название компании вместе с формой собственности.',
            'Необходимо заполнить все реквизиты компании: ИИН/БИН, Юр.Адрес, Расчетный счет, БИК, название Банка, Email, Телефон, ФИО Директора.',
            'Следующие поля являются не обязательными, если их указать они будут автоматически добавлены в документы: ФИО Бухгалтера, ФИО подписанта документов (сотрудник который подписывает Накладную и АВР), Должность подписанта.',
            'Есть возможность загрузить печать и подпись, если это сделать они будут добавлены в документы. Требования к картинкам печать и подписи: формат PNG, фон прозрачный (необходимо очистить от фона все изображение), размер от 150/150 пикселей до 500/500 пикселей.',
            'Присвоение номера документов происходит автоматически, но вы можете установить номер первого документа, от которого в дальнейшем будет вестись нумерация.',
            '',
        ],
        text_segment_bold: [
            '',
            '',
            '1. ',
            '2. ',
            '3. ',
            '4. ',
            '5. ',
            '',

        ],
        img: 3,
        ref: inputRef[2]
    },
]

const data_block_segments_directory = [
    {
        title: 'Как добавить Товары/Услуги в Справочник?',
        text_segment: [
            '',
            'Добавление нового Товара или Услуги производится путем нажатия на кнопку "+ ДОБАВИТЬ ЗАПИСЬ". После нажатия кнопки появляется пустая запись в таблице, которую необходимо заполнить.',
            'Редактирование Товара или Услуги происходит по нажатию на кнопку с изображением Карандаша. После нажатия кнопки, поля в строке где была нажата кнопка становятся доступными для редактирования.',
            'Удалить Товар или Услугу можно нажав на кнопку с изображением Корзины.',
            'Обязательно после окончания манипуляций со справочниками необходимо нажать кнопку Закрыть (в верхнем правом углу, для сохранения данных).',
            'Табличная часть:',
            'Необходимо выбрать Товар либо Услуга (от этого зависит тип сформированного документа: Накладная или АВР).',
            'Номенклатурный номер, должен быть уникальным - это порядковый номер товара.',
            'Наименование Товара или Услуги.',
            'Цена Товара или Услуги. Данная цена будет автоматически применяться в документах.',
            'Единица измерения. Для Услуги доступна только "усл.", для Товара можно выбрать одно из нескольких единиц измерения.',
            '',
        ],
        text_segment_bold: [
            '',
            '',
            '',
            '',
            '',
            '',
            '1. ',
            '2. ',
            '3. ',
            '4. ',
            '5. ',
            ''
        ],
        img: 4,
        ref: inputRef[3]
    },
    {
        title: 'Добавить Контрагента в Справочник',
        text_segment: [
            '',
            'Добавление нового Контрагента производится путем нажатия на кнопку "+ ДОБАВИТЬ ЗАПИСЬ". После нажатия кнопки появляется пустая запись в таблице, которую необходимо заполнить.',
            'Редактирование Контрагента происходит по нажатию на кнопку с изображением Карандаша. После нажатия кнопки, поля в строке где была нажата кнопка становятся доступными для редактирования.',
            'Удалить Контрагента можно нажав на кнопку с изображением Корзины.',
            'Обязательно после окончания манипуляций со справочниками необходимо нажать кнопку Закрыть (в верхнем правом углу, для сохранения данных).',
            'Табличная часть:',
            'Наименование компании - указать полное название компании вместе с формой собственности.',
            'Необходимо заполнить все реквизиты компании: ИИН/БИН, Юр.Адрес, Расчетный счет, БИК, название Банка, Почта, Телефон, КБе.',
            '',
        ],
        text_segment_bold: [
            '',
            '',
            '',
            '',
            '',
            '1. ',
            '2. ',
            '',

        ],
        img: 5,
        ref: inputRef[4]
    },
    {
        title: 'Добавить Адрес доставки в Справочнике',
        text_segment: [
            '',
            'В Накладной есть возможность указать Адрес доставки, контактного лица и его телефон, для этого необходимо добавить Адрес доставки и привязать его к компании. Адресов доставки может быть несколько для одной компании.',
            'Добавление нового Адреса доставки производится путем нажатия на кнопку "+ ДОБАВИТЬ ЗАПИСЬ". После нажатия кнопки появляется пустая запись в таблице, которую необходимо заполнить.',
            'Редактирование Адреса доставки происходит по нажатию на кнопку с изображением Карандаша. После нажатия кнопки, поля в строке где была нажата кнопка становятся доступными для редактирования.',
            'Удалить Адреса доставки можно нажав на кнопку с изображением Корзины.',
            'Обязательно после окончания манипуляций со справочниками необходимо нажать кнопку Закрыть (в верхнем правом углу, для сохранения данных).',
            'Табличная часть:',
            'Выбираем Компанию (если после создании компании ее нет в списке адреса доставки, необходимо сохранить созданную компанию, после этого она появится в списке на доставку).',
            'Вносим адрес доставки.',
            'Добавляем контактное лицо и телефон.',
            '',
        ],
        text_segment_bold: [
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '1. ',
            '2. ',
            '3. ',
            '',

        ],
        img: 6,
        ref: inputRef[5]
    },
    {
        title: 'Добавить Группу расходов в Справочник',
        text_segment: [
            '',
            'Группы расходов используются во вкладе "Расходы" для группировки текущих расходов в разрезе месяца.',
            'На вкладе "Расходы" имеется диаграмма, которая формируется именно по группам расходов.',
            'Заполнять данный раздел не обязательно, в программе предусмотрены Группы расходов по умолчанию: Зарплата, Аренда, Транспорт, Бухгалтерия и Маркетинг.',
            'Как добавить новую Группу расходов:',
            'Нажимаем на кнопку "+ ДОБАВИТЬ ЗАПИСЬ."',
            'Вписываем название Группы и нажимаем сохранить 💾',
            '',
        ],
        text_segment_bold: [
            '',
            '',
            '',
            '',
            '',
            '1. ',
            '2. ',
            '',

        ],
        img: 7,
        ref: inputRef[6]
    },
    {
        title: 'Добавить Точку продажи в Справочник',
        text_segment: [
            '',
            'Точка продажи используется для составления Налогового отчета ФНО 913.00 и обязательна к заполнению для компании работающей по налоговому режиму "Розничный налог".',
            'После добавления Точки продажи, в настройках Компании можно выбрать данную точку для отображения по умолчанию в Заявках или при создании Заявки можно выбрать Точку продаж.',
            'Как добавить новую Точку продаж:',
            'Нажимаем на кнопку "+ ДОБАВИТЬ ЗАПИСЬ."',
            'Выбираем Налоговый орган в котором зарегистрирована ваша компания.',
            'Заполняем все поля адреса Точки и нажимаем сохранить 💾',
            'Можно добавить несколько Точек продаж.',
            '',
        ],
        text_segment_bold: [
            '',
            '',
            '',
            '1. ',
            '2. ',
            '3. ',
            '4. ',
            '',

        ],
        img: 8,
        ref: inputRef[7]
    },
]
    return <>
        <Container maxWidth="xl" sx={{ mt: { xs: 8, md: 20 } }}>
            <Grid container spacing={1} sx={{ justifyContent: 'center', borderBottom: 2, borderColor: '#fcbb42', borderBottomStyle: 'inset', pb: { xs: 2, md: 5 } }}>
                <Grid item md={12} lg={6} sx={{ display: 'flex', justifyContent: 'right'}} >
                    <img alt='Online Бухгалтер' src={topImg} style={{ width: '90%', border: 5, marginLeft: 'auto', marginRight: 'auto' }} />
                </Grid>
                <Grid item md={12} lg={6}  >
                    <Typography variant="h1" fontStyle={'italic'} fontSize={{ xs: '1.5em', md: '2em' }} textAlign={'center'} color={'#5d5d5d'} sx={{ mt: { xs: 0.5, md: 2 } }} >
                        Online(Онлайн) Бухгалтер - Инструкции
                    </Typography>
                    <ListSettings listItem={listSettingsLink} />
                </Grid>
            </Grid>

            <Container maxWidth="xl" sx={{ mt: 5, p: { xs: 'default', md: 0 } }}>
                <Grid container spacing={5} sx={{ justifyContent: 'center', borderBottom: 2, borderColor: '#fcbb42', borderBottomStyle: 'inset', pb: 3 }}>
                    <Grid item md={12} lg={12} sx={{ justifyContent: 'center' }} >
                        <Typography variant="h2" fontStyle={'italic'} fontSize={{ xs: '1.5em', md: '2em' }} textAlign={'center'} color={'#5d5d5d'} sx={{ mt: { xs: 0.5, md: 2 } }} >
                            Регистрация пользователя и компании в системе Online Бухгалтер
                        </Typography>
                    </Grid>
                    {data_block_segments.map((item)=>(
                        <Grid ref={item.ref} key={item.title} item md={12} lg={12}  >
                        <SegmentsRounded title={item.title} text={item.text_segment} textBold={item.text_segment_bold} imgIndex={item.img} />
                    </Grid>
                    ))}
                </Grid>
            </Container>

            <Container maxWidth="xl" sx={{ mt: 5, p: { xs: 'default', md: 0 } }}>
                <Grid container spacing={5} sx={{ justifyContent: 'center', borderBottom: 2, borderColor: '#fcbb42', borderBottomStyle: 'inset', pb: 3 }}>
                    <Grid item md={12} lg={12} sx={{ justifyContent: 'center' }} >
                        <Typography variant="h2" fontStyle={'italic'} fontSize={{ xs: '1.5em', md: '2em' }} textAlign={'center'} color={'#5d5d5d'} sx={{ mt: { xs: 0.5, md: 2 } }} >
                            Заполнение Справочника в системе Online Бухгалтер
                        </Typography>
                    </Grid>
                    {data_block_segments_directory.map((item)=>(
                        <Grid ref={item.ref} key={item.title} item md={12} lg={12}  >
                        <SegmentsRounded title={item.title} text={item.text_segment} textBold={item.text_segment_bold} imgIndex={item.img} />
                    </Grid>
                    ))}
                </Grid>
            </Container>
        </Container>
    </>
}

export default SettingsOnlineBuhgalterPage;
